const FilterItem = ({ filter, filtersState, filterName, setFiltersState, itemDiv, filters, setSelectedInstitution }) => {

  
  const handleFilter = (id) => {
    let newFilters = JSON.parse(JSON.stringify(filtersState));
    if (filtersState[filterName].indexOf(id) === -1 || filtersState[filterName].length === 0) {
      setFiltersState((prevfilter) => ({
        ...prevfilter,
        [filterName]: [...prevfilter[filterName], id],
      }));
      newFilters[filterName].push(id);
    } else if (newFilters[filterName].indexOf(id) > -1) {
      newFilters[filterName] = newFilters[filterName].filter((elt) => elt !== id);
      setFiltersState(newFilters);
    }
  };

  return (
    <div key={filter.id} className={itemDiv}>
      <div className="generic-filter__item" key={filter.id} onClick={() => handleFilter(filter.name)}>
        {/* {filters[filterName]['icon'] !== '' &&
                        <div dangerouslySetInnerHTML={{ __html: filter["icon"]}}></div>
                    } */}
        <div className="generic-filter__item--name">{filter.name}</div>
      </div>
    </div>
  );
};

export default FilterItem;
